import { Button, Card, Col, Row, Spin, Switch, Tabs, Radio, Typography, Divider, Space, Tag, Tooltip, Image, Popconfirm } from "antd";
import { DeleteOutlined, ArrowUpOutlined, ArrowDownOutlined, PictureOutlined } from "@ant-design/icons";
import HeaderComponent from "../../components/header/headerComponent";
import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";
import MobileViewTextDragComponentAds from "../../components/newsManagemet/MobileViewTextDragComponentAds";
import { ADSSETTING_URL, PRODUCT_URL } from "../../api/URLs";
import { getDataRequest, postDataRequest } from "../../api/serviceMethods";
import DragUploadAdsSettingComponent from "../../components/upload/DragUploadAdsSettingComponent";
import SelectComponent from "../../components/select/SelectComponent";
import AdsSettingInternalLinkSelector from "../../components/common/AdsSettingInternalLinkSelector";
import InputComponent from "../../components/input/InputComponent";
import MessageConfirmModal from "../../components/messageModal/MessageConfirmModal";
import OSSUploadWrapper from "../../components/upload/OSSUploadWrapper";
import { RemoveSvg } from "../../assets/images/RemoveSvg";
import { formatFileSize, getFileType } from "../../utils/string";

const { Text, Title } = Typography;

const AdsSettingMainPage = (props) => {
  const { t } = useTranslation();
  const messageModalRef = useRef("");

  // Top-level Ad category tab: 'splash' | 'banner' | 'popup'
  const [activeCategoryTab, setActiveCategoryTab] = useState("splash");

  // Splash Ad states
  const [AdsTab, setAdsTab] = useState('external');
  const [picUrl, setpicUrl] = useState(null);
  const [splashExternalUrl, setSplashExternalUrl] = useState('');
  const [splashInternalUrl, setSplashInternalUrl] = useState('');
  const [splashInternalId, setSplashInternalId] = useState(null);
  const [splashInternalType, setSplashInternalType] = useState(null);
  const [splashInternalTargetId, setSplashInternalTargetId] = useState(null);
  const [splashStatus, setSplashStatus] = useState(false);
  const [dataObject, setDataObject] = useState({
    picUrl: "",
    fileSize: "",
    fileName: "",
    linkType: "external",
    linkUrl: "",
    status: false,
    linkId: null
  });

  // Banner Ads states (Homepage rotating banners before Contact Us)
  const [banners, setBanners] = useState([]);
  const [statusBanners, setStatusBanners] = useState(false);

  // Section Pop-up Ads states
  const [popupPicUrl, setPopupPicUrl] = useState(null);
  const [popupLinkType, setPopupLinkType] = useState('external');
  const [popupExternalUrl, setPopupExternalUrl] = useState('');
  const [popupInternalUrl, setPopupInternalUrl] = useState('');
  const [popupInternalId, setPopupInternalId] = useState(null);
  const [popupInternalType, setPopupInternalType] = useState(null);
  const [popupInternalTargetId, setPopupInternalTargetId] = useState(null);

  const [popupProductId, setPopupProductId] = useState('');
  const [popupSection, setPopupSection] = useState(['all']);
  const [statusSectionAds, setStatusSectionAds] = useState(false);



  // Shared states
  const [loading, setLoading] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [productList, setProductList] = useState([]);

  const sectionOptions = [
    { label: t("All Sections"), value: "all" },
    { label: t("Magazine"), value: "magazine" },
    { label: t("News"), value: "news" },
    { label: t("Product"), value: "product" },
    { label: t("Technique"), value: "technology" },
    { label: t("Fashion"), value: "fashion" },
  ];

  const handleSectionChange = (value) => {
    if (!value || value.length === 0) {
      setPopupSection([]);
      return;
    }
    const hadAll = Array.isArray(popupSection) && popupSection.includes("all");
    const hasAll = value.includes("all");

    if (hasAll && !hadAll) {
      // User just selected "All Sections" -> clear other sections
      setPopupSection(["all"]);
    } else if (hasAll && hadAll && value.length > 1) {
      // User had "All Sections" and just selected another section -> remove "All Sections"
      setPopupSection(value.filter((v) => v !== "all"));
    } else {
      setPopupSection(value);
    }
  };

  const handleSplashTabChange = (activeKey) => {
    if (activeKey === 'externalList') {
      setAdsTab('external');
    } else if (activeKey === 'internalList') {
      setAdsTab('internal');
    }
  };

  const handlePopupTabChange = (activeKey) => {
    if (activeKey === 'externalList') {
      setPopupLinkType('external');
    } else if (activeKey === 'internalList') {
      setPopupLinkType('internal');
    }
  };

  const handleBannerLinkTypeChange = (index, linkType) => {
    setBanners(prev => {
      const updated = [...(prev || [])];
      if (updated[index]) {
        updated[index] = {
          ...updated[index],
          linkType: linkType,
        };
      }
      return updated;
    });
  };

  const handleBannerExternalUrlChange = (index, value) => {
    setBanners(prev => {
      const updated = [...(prev || [])];
      if (updated[index]) {
        updated[index] = {
          ...updated[index],
          externalLinkUrl: value,
        };
      }
      return updated;
    });
  };

  const handleBannerInternalChange = (index, { linkUrl, linkId, type, targetId }) => {
    setBanners(prev => {
      const updated = [...(prev || [])];
      if (updated[index]) {
        updated[index] = {
          ...updated[index],
          internalLinkUrl: linkUrl || "",
          internalLinkId: linkId || null,
          internalType: type || null,
          internalTargetId: targetId || null,


        };
      }
      return updated;
    });
  };

  const getLinkAdsSetting = async () => {
    try {
      setLoading(true);
      const res = await getDataRequest(`${ADSSETTING_URL}`);
      if (res.status === 200 && res.data) {
        const d = res.data;
        const splashLinkId = d?.linkId?._id || d?.linkId?.id || d?.linkId?.value || (typeof d?.linkId === 'string' ? d?.linkId : null);
        const resolvedSplashLinkId = splashLinkId || null;
        const isSplashInternal = d?.linkType === "internal";
        setAdsTab(isSplashInternal ? 'internal' : 'external');
        setSplashStatus(d?.status !== undefined ? d.status : false);
        if (isSplashInternal) {
          setSplashInternalUrl(d?.linkUrl || (d?.productId ? `/product/${d.productId}` : ""));
          setSplashInternalId(resolvedSplashLinkId);
          setSplashInternalType(d?.type || d?.type || null);
          setSplashInternalTargetId(d?.targetId || null);
          setSplashExternalUrl('');
        } else {
          setSplashExternalUrl(d?.linkUrl || '');
          setSplashInternalUrl('');
          setSplashInternalId(null);
          setSplashInternalType(null);
          setSplashInternalTargetId(null);
        }
        setDataObject({
          picUrl: d?.picUrl || "",
          fileSize: d?.fileSize || "",
          fileName: d?.fileName || ""





        });


        // Populate Splash screen ad
        if (d?.picUrl) {
          setpicUrl([
            {
              name: d?.fileName || "",
              size: d?.fileSize || "",
              url: d?.picUrl || "",
            }
          ]);
        } else {
          setpicUrl([]);
        }

        // Populate Rotating Banners
        let initialBanners = [];
        if (d?.banners && d.banners.length > 0) {
          initialBanners = d.banners.map(b => {
            const rawLinkId = b?.linkId?._id || b?.linkId?.id || b?.linkId?.value || (typeof b?.linkId === 'string' ? b.linkId : null);
            const bLinkType = b?.linkType === 'internal' ? 'internal' : 'external';
            const bLinkUrl = b?.linkUrl || '';
            return {
              name: b.name || "",
              size: b.size || "",
              url: b.url || "",
              linkType: bLinkType,
              externalLinkUrl: bLinkType === 'external' ? (b?.linkUrl || '') : '',
              internalLinkUrl: bLinkType === 'internal' ? (b?.linkUrl || (b?.productId ? `/product/${b.productId}` : '')) : '',
              internalLinkId: bLinkType === 'internal' ? (rawLinkId || null) : null,
              internalType: bLinkType === 'internal' ? (b?.type || b?.type || null) : null,
              internalTargetId: bLinkType === 'internal' ? (b?.targetId || null) : null,




            };
          });
        }
        setBanners(initialBanners);

        // Populate Section Popup Ad
        const popupData = d?.sectionAds || d?.sectionPopup || {};
        const pUrl = popupData?.picUrl || d?.popupPicUrl || "";
        const pName = popupData?.fileName || d?.popupFileName || "";
        const pSize = popupData?.fileSize || d?.popupFileSize || "";

        if (pUrl) {
          setPopupPicUrl([
            {
              name: pName,
              size: pSize,
              url: pUrl,
            }
          ]);
        } else {
          setPopupPicUrl([]);
        }

        const targetSec = popupData?.targetSection || d?.popupSection || 'all';
        const initialSection = Array.isArray(targetSec)
          ? (targetSec.length > 0 ? targetSec : ['all'])
          : (targetSec ? [targetSec] : ['all']);

        const pLinkType = popupData?.linkType || d?.popupLinkType || 'external';
        const pLinkUrl = popupData?.linkUrl || d?.popupLinkUrl || '';
        const pRawLinkId = popupData?.linkId || d?.popupLinkId || null;
        const pLinkId = pRawLinkId?._id || pRawLinkId?.id || pRawLinkId?.value || (typeof pRawLinkId === 'string' ? pRawLinkId : null);
        const resolvedPopupLinkId = pLinkId || null;

        const isPopupInternal = pLinkType === 'internal';
        setPopupLinkType(isPopupInternal ? 'internal' : 'external');

        if (isPopupInternal) {
          setPopupInternalUrl(popupData?.linkUrl || (popupData?.productId ? `/product/${popupData.productId}` : ''));
          setPopupInternalId(resolvedPopupLinkId);
          setPopupInternalType(popupData?.type || popupData?.type || d?.popupType || d?.popuptype || null);
          setPopupInternalTargetId(popupData?.targetId || d?.popupTargetId || null);
          setPopupExternalUrl('');
        } else {
          setPopupExternalUrl(popupData?.linkUrl || d?.popupLinkUrl || '');
          setPopupInternalUrl('');
          setPopupInternalId(null);
          setPopupInternalType(null);
          setPopupInternalTargetId(null);
        }



        setPopupSection(initialSection);




        setStatusBanners(d?.statusBanners !== undefined ? d.statusBanners : (d?.bannerStatus !== undefined ? d.bannerStatus : false));
        setStatusSectionAds(d?.statusSectionAds !== undefined ? d.statusSectionAds : (popupData?.status !== undefined ? popupData.status : (d?.popupStatus !== undefined ? d.popupStatus : false)));
      }
    } catch (error) {
      console.error("Error fetching ads setting data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchProduct = async () => {
    try {
      const res = await getDataRequest(`${PRODUCT_URL}`, { status: true });
      if (res.status === 200 && res?.data) {
        const datas = res.data
          .filter((it) => it.status !== false && it.status !== 0 && it.status !== "false")
          .map((it) => ({
            label: it.name || "",
            value: it._id,
            productId: it.productId || it._id,
          }));
        setProductList(datas);
      }
    } catch (err) {
      console.error("Error fetching products:", err);
    }
  };

  useEffect(() => {
    getLinkAdsSetting();
    fetchProduct();
  }, []);

  const checkError = () => {
    if (activeCategoryTab === "splash") {
      if (!picUrl || !picUrl[0]?.url) {
        messageModalRef.current.showWarningConfirmsAutoClose(t("Please upload a valid splash screen image."), () => { }, "", true);
        return true;
      }
    } else if (activeCategoryTab === "banner") {
      if (!banners || banners.length === 0) {
        messageModalRef.current.showWarningConfirmsAutoClose(t("Please upload at least one banner image."), () => { }, "", true);
        return true;
      }
    } else if (activeCategoryTab === "popup") {
      if (!popupPicUrl || !popupPicUrl[0]?.url) {
        messageModalRef.current.showWarningConfirmsAutoClose(t("Please upload a valid popup image."), () => { }, "", true);
        return true;
      }
    }
    return false;
  };

  const handleSubmit = async () => {
    setIsSubmit(true);

    if (checkError()) {
      return false;
    }

    setLoading(true);

    const pic = picUrl?.[0] || {};
    const obj = dataObject || {};
    const popupPic = popupPicUrl?.[0] || {};

    const bannersPayload = (banners || []).map(p => {
      const isInternal = p.linkType === "internal";


      return {
        url: p.url || "",
        size: p.size ? Number(p.size) : 0,
        name: p.name || "",
        linkType: isInternal ? "internal" : "external",
        linkUrl: isInternal ? (p.internalLinkUrl || "") : (p.externalLinkUrl || ""),
        linkId: isInternal ? (p.internalLinkId?._id || p.internalLinkId?.value || (typeof p.internalLinkId === 'string' ? p.internalLinkId : null)) : null,
        type: isInternal ? (p.internalType || null) : null,
      };
    });

    const targetSectionValue = Array.isArray(popupSection) 
      ? popupSection 
      : (popupSection ? [popupSection] : ["all"]);

    const isSplashInternal = AdsTab === "internal";
    const splashLinkId = isSplashInternal ? (splashInternalId?._id || splashInternalId?.value || (typeof splashInternalId === 'string' ? splashInternalId : null)) : null;
    const splashLinkUrl = isSplashInternal ? (splashInternalUrl || "") : (splashExternalUrl || "");
    const splashType = isSplashInternal ? (splashInternalType || null) : null;
    const splashTargetId = isSplashInternal ? (splashInternalTargetId || null) : null;

    const isPopupInternal = popupLinkType === "internal";
    const secLinkId = isPopupInternal ? (popupInternalId?._id || popupInternalId?.value || (typeof popupInternalId === 'string' ? popupInternalId : null)) : null;
    const secLinkUrl = isPopupInternal ? (popupInternalUrl || "") : (popupExternalUrl || "");
    const secType = isPopupInternal ? (popupInternalType || null) : null;
    const secTargetId = isPopupInternal ? (popupInternalTargetId || null) : null;





    const adsSettingPayload = {
      picUrl: pic.url || "",
      fileSize: pic.size ? Number(pic.size) : 0,
      fileName: pic.name || "",
      linkType: isSplashInternal ? "internal" : "external",
      linkUrl: splashLinkUrl,
      linkId: splashLinkId,
      type: splashType,
      status: splashStatus,


      // productId: splashProductId,

      statusBanners: statusBanners !== undefined ? statusBanners : false,
      statusSectionAds: statusSectionAds !== undefined ? statusSectionAds : false,
      banners: bannersPayload,
      // bannerStatus: statusBanners !== undefined ? statusBanners : true,
      sectionAds: {
        picUrl: popupPic.url || "",
        fileSize: popupPic.size ? Number(popupPic.size) : 0,
        fileName: popupPic.name || "",
        linkType: isPopupInternal ? "internal" : "external",
        linkUrl: secLinkUrl,
        linkId: secLinkId,
        type: secType,


        // productId: secProductId,
        targetSection: targetSectionValue,
        // status: statusSectionAds !== undefined ? statusSectionAds : false
      }
    };

    try {
      const res = await postDataRequest(ADSSETTING_URL, adsSettingPayload);
      if (res?.status === 200) {
        messageModalRef.current.showSuccessConfirmsAutoClose(t(res?.message) || t('Saved Successfully'), () => { }, "", true);
        getLinkAdsSetting();
      } else {
        messageModalRef.current.showWarningConfirmsAutoClose(res.data?.message || res.message || t("An error occurred"));
      }
    } catch (err) {
      messageModalRef.current.showWarningConfirmsAutoClose(err?.message || "Server Error!", () => { }, "", true);
    } finally {
      setLoading(false);
      setIsSubmit(false);
    }
  };

  return (
    <>
      <style>{`
        .banner-config-tabs.ant-tabs .ant-tabs-nav .ant-tabs-nav-wrap {
          padding-left: 0px !important;
        }
        .banner-config-tabs.ant-tabs .ant-tabs-nav {
          margin-bottom: 6px !important;
        }
      `}</style>
      <HeaderComponent pageTitle={t('Ads Settings')}>
        <Spin spinning={loading}>
          <div style={{ padding: "30px 40px" }}>
            <Row gutter={[24, 24]}>
              
              {/* LEFT COLUMN: LIVE MOBILE PHONE MOCKUP PREVIEW */}
              <Col xs={24} lg={8} xl={7}>
                <div className='w-100 h-100'>
                  <MobileViewTextDragComponentAds
                    fileList={picUrl ? picUrl : []}
                    picUrl={picUrl?.[0]?.url || dataObject?.picUrl || ""}
                    dataObject={dataObject}
                    AdsTab={AdsTab}
                    activeAdSection={activeCategoryTab}
                    banners={banners}
                    popupPicUrl={popupPicUrl?.[0]?.url || ""}
                    popupFileList={popupPicUrl ? popupPicUrl : []}
                    popupSection={popupSection}
                  />
                </div>
              </Col>

              {/* RIGHT COLUMN: AD CONFIGURATION FOR THE 3 TYPES */}
              <Col xs={24} lg={16} xl={17}>
                <Card style={{ borderRadius: "12px", boxShadow: "0 2px 10px rgba(0,0,0,0.04)" }}>
                  
                  {/* TOP-LEVEL 3 AD TYPE SELECTOR TABS */}
                  <Tabs
                    activeKey={activeCategoryTab}
                    onChange={(key) => setActiveCategoryTab(key)}
                    type="card"
                    size="large"
                    items={[
                      {
                        key: 'splash',
                        label: t('App Splash Screen Ads'),
                      },
                      {
                        key: 'banner',
                        label: t('Homepage Banner Ads'),
                      },
                      {
                        key: 'popup',
                        label: t('Section Ad Pop-ups'),
                      },
                    ]}
                  />

                  {/* ===================== TAB 1: APP SPLASH SCREEN ADS ===================== */}
                  {activeCategoryTab === 'splash' && (
                    <div style={{ marginTop: "16px" }}>
                      <div className="mb-3">
                        <Title level={5} style={{ margin: 0, color: "#1F2937" }}>
                          {t('App Splash Screen Ads')}
                        </Title>
                        <Text type="secondary" style={{ fontSize: "13px" }}>
                          {t('Configure full-screen advertisement image displayed upon opening the mobile application.')}
                        </Text>
                      </div>

                      {/* Image / GIF Upload Zone */}
                      <Row className='w-100'>
                        <Col md={24} sm={24}>
                          <div className='w-100'>
                            <OSSUploadWrapper
                              allowType={["image/png", "image/jpg", "image/jpeg", "image/gif", "image/webp"]}
                              onUploadSuccess={(value) => {
                                setpicUrl([value]);
                                setDataObject(prev => ({
                                  ...prev,
                                  picUrl: value.url,
                                  fileName: value.name,
                                  fileSize: value.size
                                }));
                              }}
                            >
                              <DragUploadAdsSettingComponent
                                allowType={["image/png", "image/jpg", "image/jpeg", "image/gif", "image/webp"]}
                                titleallowFile={t(`Support png/jpg/gif and other formats, the maximum file size is 10MB`)}
                                fileList={picUrl ? picUrl : []}
                                setFileList={(values) => {
                                  setpicUrl(values);
                                  if (values.length === 0) {
                                    setDataObject(prev => ({
                                      ...prev,
                                      picUrl: "",
                                      fileName: "",
                                      fileSize: ""
                                    }));
                                  }
                                }}
                              />
                            </OSSUploadWrapper>
                          </div>
                        </Col>
                      </Row>

                      {/* Jump Link Configuration */}
                      <div className="mt-4">
                        <Card
                          className="custom-card"
                          bodyStyle={{ padding: "16px 20px" }}
                          style={{ background: "#FFFFFF", borderRadius: "10px", border: "1px solid #E5E7EB", boxShadow: "0 1px 3px rgba(0,0,0,0.03)" }}
                        >
                          <Tabs
                            activeKey={AdsTab === "internal" ? "internalList" : "externalList"}
                            className="banner-config-tabs cusStyle"
                            onChange={handleSplashTabChange}
                            items={[
                              {
                                key: "externalList",
                                label: (
                                  <span style={{ display: "inline-flex", alignItems: "center", gap: "6px", fontSize: "13px" }}>
                                    {/* <GlobalOutlined /> */}
                                    <span>{t("External Links")}</span>
                                  </span>
                                ),
                                children: (
                                  <div style={{ paddingTop: "6px" }}>
                                    <div style={{ fontSize: "12px", fontWeight: 500, color: "#4B5563", marginBottom: "6px" }}>
                                      {t("Enter Jump Link")} :
                                    </div>
                                    <InputComponent
                                      placeholder=""
                                      value={splashExternalUrl || ""}
                                      setValue={(value) => setSplashExternalUrl(value)}
                                    />
                                  </div>
                                )
                              },
                              {
                                key: "internalList",
                                label: (
                                  <span style={{ display: "inline-flex", alignItems: "center", gap: "6px", fontSize: "13px" }}>
                                    {/* <ShoppingOutlined /> */}
                                    <span>{t("Internal Links")}</span>
                                  </span>
                                ),
                                children: (
                                  <div style={{ paddingTop: "6px" }}>
                                    <AdsSettingInternalLinkSelector
                                      value={{
                                        linkUrl: splashInternalUrl,
                                        linkId: splashInternalId,
                                        type: splashInternalType,

                                        targetId: splashInternalTargetId
                                      }}
                                      onChange={({ linkUrl, linkId, type, targetId }) => {
                                        setSplashInternalUrl(linkUrl || "");
                                        setSplashInternalId(linkId || null);
                                        setSplashInternalType(type || null);
                                        setSplashInternalTargetId(targetId || null);
                                      }}
                                    />
                                  </div>
                                )
                              }
                            ]}
                          />
                        </Card>
                      </div>

                      {/* Splash Ad Status */}
                      <Row align="middle" className='mt-4 mb-4'>
                        <Col md={3} sm={6} style={{ fontWeight: 500 }}>
                          {t("Status")} :
                        </Col>
                        <Col md={21} sm={18}>
                          <Switch
                            checked={splashStatus}
                            onChange={(checked) => setSplashStatus(checked)}
                          />
                        </Col>
                      </Row>
                    </div>
                  )}

                  {/* ===================== TAB 2: HOMEPAGE ROTATING BANNER ADS ===================== */}
                  {activeCategoryTab === 'banner' && (
                    <div style={{ marginTop: "16px" }}>
                      <div className="mb-3">
                        <Title level={5} style={{ margin: 0, color: "#1F2937" }}>
                          {t('Rotating Banner Ads (Homepage - Before Contact Us)')}
                        </Title>
                        <Text type="secondary" style={{ fontSize: "13px" }}>
                          {t('Banner ads appear before the Contact Us section on the homepage. Multiple uploaded images or GIFs will rotate automatically.')}
                        </Text>
                      </div>

                      {/* Multiple Banner Upload Zone */}
                      <Row className='w-100'>
                        <Col md={24} sm={24}>
                          <div className='w-100'>
                            <OSSUploadWrapper
                              allowType={["image/png", "image/jpg", "image/jpeg", "image/gif", "image/webp"]}
                              onUploadSuccess={(value) => {
                                setBanners(prev => [
                                  ...(prev || []),
                                  {
                                    ...value,
                                    linkType: "external",
                                    linkUrl: "",
                                    linkId: null
                                  }
                                ]);
                              }}
                            >
                              <DragUploadAdsSettingComponent
                                size={10}
                                titleallowFile={t(`Support png/jpg/gif and other formats, the maximum file size is 10MB`)}
                                allowType={["image/png", "image/jpg", "image/jpeg", "image/gif", "image/webp"]}
                                fileList={banners ? banners : []}
                                setFileList={(values) => {
                                  setBanners(values.map(v => ({
                                    ...v,
                                    linkType: v.linkType || "external",
                                    linkUrl: v.linkUrl || "",
                                    linkId: v.linkId || null,
                                    productId: v.productId || ""
                                  })));
                                }}
                              />
                            </OSSUploadWrapper>
                          </div>
                        </Col>
                      </Row>

                      {/* Banner Link Configuration */}
                      <div className="mt-4">
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "14px" }}>
                          <div>
                            <Title level={5} style={{ margin: 0, color: "#1F2937", fontSize: "15px", fontWeight: 600 }}>
                              {t("Banner Link Configuration")}
                            </Title>
                            <Text type="secondary" style={{ fontSize: "12px" }}>
                              {t("Configure individual redirect links and targets for each uploaded banner.")}
                            </Text>
                          </div>
                          {banners && banners.length > 0 && (
                            <Tag color="default" style={{ borderRadius: "12px", padding: "2px 10px", fontWeight: 500, fontSize: "12px" }}>
                              {banners.length} {banners.length === 1 ? t("Banner") : t("Banners")}
                            </Tag>
                          )}
                        </div>

                        {(!banners || banners.length === 0) ? (
                          <div style={{
                            textAlign: "center",
                            padding: "36px 20px",
                            color: "#9CA3AF",
                            background: "#FAFAFA",
                            borderRadius: "10px",
                            border: "1px dashed #E5E7EB"
                          }}>
                            <PictureOutlined style={{ fontSize: "28px", color: "#D1D5DB", marginBottom: "8px", display: "block" }} />
                            <div style={{ fontSize: "13px", fontWeight: 500, color: "#6B7280" }}>
                              {t("No banners uploaded yet")}
                            </div>
                            <div style={{ fontSize: "12px", color: "#9CA3AF", marginTop: "2px" }}>
                              {t("Upload banner images above to configure redirect links.")}
                            </div>
                          </div>
                        ) : (
                          banners.map((item, index) => {
                            const isInternal = item.linkType === "internal";
                            const targetId = item?.linkId?.id || item?.linkId?._id || item?.linkId?.value || item?.linkId;
                            const matchedProduct = targetId ? productList.find(p => p.value === targetId || p.productId === targetId) : null;
                            const hasProductError = isSubmit && isInternal && item.linkId && !matchedProduct;

                            return (
                              <Card
                                key={item.uid || item.url || index}
                                className="mb-3 banner-card"
                                bodyStyle={{ padding: "16px 20px" }}
                                style={{
                                  background: "#FFFFFF",
                                  borderRadius: "12px",
                                  border: "1px solid #E5E7EB",
                                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.02)",
                                  transition: "all 0.2s ease"
                                }}
                              >
                                {/* Card Header with Banner Tag, Filename, Size, and Actions */}
                                <div style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  paddingBottom: "12px",
                                  marginBottom: "14px",
                                  borderBottom: "1px solid #F3F4F6",
                                  flexWrap: "wrap",
                                  gap: "8px"
                                }}>
                                  <div style={{ display: "flex", alignItems: "center", gap: "10px", minWidth: 0, flex: 1 }}>
                                    <Tag
                                      style={{
                                        margin: 0,
                                        padding: "2px 10px",
                                        borderRadius: "6px",
                                        fontWeight: 600,
                                        fontSize: "12px",
                                        background: "#FFF1F2",
                                        color: "#E50A47",
                                        border: "1px solid #FFE4E6",
                                        flexShrink: 0
                                      }}
                                    >
                                      {t("Banner")} #{index + 1}
                                    </Tag>
                                    {/* <Tooltip title={item.name || `Banner ${index + 1}`}> */}
                                      <Text
                                        style={{
                                          fontSize: "13px",
                                          fontWeight: 600,
                                          color: "#1F2937",
                                          maxWidth: "340px",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          whiteSpace: "nowrap"
                                        }}
                                      >
                                        {item.name || `Banner ${index + 1}`}
                                      </Text>
                                    {/* </Tooltip> */}
                                    {item.size ? (
                                      <Text type="secondary" style={{ fontSize: "12px", whiteSpace: "nowrap", flexShrink: 0 }}>
                                        • {formatFileSize(item.size)}
                                      </Text>
                                    ) : null}
                                  </div>

                                  {/* Right Controls: Move Up/Down + Remove */}
                                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                    {/* {banners.length > 1 && (
                                      <Space size={2}>
                                        <Tooltip title={t("Move Up")}>
                                          <Button
                                            size="small"
                                            type="text"
                                            disabled={index === 0}
                                            icon={<ArrowUpOutlined />}
                                            onClick={() => handleMoveBanner(index, "up")}
                                            style={{ color: index === 0 ? "#D1D5DB" : "#6B7280" }}
                                          />
                                        </Tooltip>
                                        <Tooltip title={t("Move Down")}>
                                          <Button
                                            size="small"
                                            type="text"
                                            disabled={index === banners.length - 1}
                                            icon={<ArrowDownOutlined />}
                                            onClick={() => handleMoveBanner(index, "down")}
                                            style={{ color: index === banners.length - 1 ? "#D1D5DB" : "#6B7280" }}
                                          />
                                        </Tooltip>
                                      </Space>
                                    )} */}
                                    {/* <Popconfirm
                                      title={t("Delete Banner")}
                                      description={t("Are you sure you want to remove this banner?")}
                                      onConfirm={() => {
                                        setBanners(prev => prev.filter((_, idx) => idx !== index));
                                      }}
                                      okText={t("Yes")}
                                      cancelText={t("No")}
                                    >
                                      <Button
                                        type="text"
                                        size="small"
                                        danger
                                        icon={<DeleteOutlined />}
                                        style={{
                                          display: "inline-flex",
                                          alignItems: "center",
                                          fontSize: "12px",
                                          borderRadius: "4px"
                                        }}
                                      >
                                        {t("Remove")}
                                      </Button>
                                    </Popconfirm> */}
                                    <div>
                                      <span className='remove-icon' onClick={() => setBanners(prev => prev.filter((_, idx) => idx !== index))} style={{ cursor: "pointer" }}><RemoveSvg /></span>
                                    </div>
                                  </div>
                                </div>

                                {/* Card Body: Left Thumbnail Preview + Right Link Configuration */}
                                <Row gutter={[20, 16]} align="middle">
                                  {/* Left: Thumbnail with click zoom */}
                                  <Col xs={24} sm={8} md={6}>
                                    <div style={{
                                      position: "relative",
                                      width: "100%",
                                      height: "85px",
                                      borderRadius: "8px",
                                      overflow: "hidden",
                                      border: "1px solid #E5E7EB",
                                      background: "#F9FAFB",
                                      boxShadow: "0 1px 2px rgba(0,0,0,0.03)"
                                    }}>
                                      <Image
                                        wrapperStyle={{
                                          width: "100%",
                                          height: "100%",
                                          display: "block"
                                        }}
                                        src={item.url}
                                        alt={item.name || `Banner ${index + 1}`}
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          objectFit: "cover",
                                          display: "block"
                                        }}
                                        fallback="https://via.placeholder.com/160x90?text=Banner"
                                      />
                                    </div>
                                  </Col>

                                  {/* Right: Clean Link Configuration Tabs */}
                                  <Col xs={24} sm={16} md={18}>
                                    <Tabs
                                      activeKey={isInternal ? "internalList" : "externalList"}
                                      className="banner-config-tabs cusStyle"
                                      onChange={(key) => handleBannerLinkTypeChange(index, key === "internalList" ? "internal" : "external")}
                                      style={{ marginBottom: 0 }}
                                      items={[
                                        {
                                          key: "externalList",
                                          label: (
                                            <span style={{ display: "inline-flex", alignItems: "center", gap: "6px", fontSize: "13px" }}>
                                              {/* <GlobalOutlined /> */}
                                              <span>{t("External Links")}</span>
                                            </span>
                                          ),
                                          children: (
                                            <div style={{ paddingTop: "6px" }}>
                                              <div style={{ fontSize: "12px", fontWeight: 500, color: "#4B5563", marginBottom: "6px" }}>
                                                {t("Enter Jump Link")} :
                                              </div>
                                              <InputComponent
                                                placeholder=""
                                                value={item.externalLinkUrl || ""}
                                                setValue={(value) => handleBannerExternalUrlChange(index, value)}
                                              />
                                            </div>
                                          )
                                        },
                                        {
                                          key: "internalList",
                                          label: (
                                            <span style={{ display: "inline-flex", alignItems: "center", gap: "6px", fontSize: "13px" }}>
                                              {/* <ShoppingOutlined /> */}
                                              <span>{t("Internal Links")}</span>
                                            </span>
                                          ),
                                          children: (
                                            <div style={{ paddingTop: "6px" }}>
                                              <AdsSettingInternalLinkSelector
                                                value={{
                                                  linkUrl: item.internalLinkUrl || "",
                                                  linkId: item.internalLinkId || null,
                                                  type: item.internalType || null,
                                                  targetId: item.internalTargetId || null
                                                }}
                                                onChange={(val) => handleBannerInternalChange(index, val)}
                                              />
                                            </div>
                                          )
                                        }
                                      ]}
                                    />
                                  </Col>
                                </Row>
                              </Card>
                            );
                          })
                        )}
                      </div>

                      {/* Banner Overall Status */}
                      <Row align="middle" className='mt-4 mb-4'>
                        <Col md={3} sm={6} style={{ fontWeight: 500 }}>
                          {t("Status")} :
                        </Col>
                        <Col md={21} sm={18}>
                          <Switch
                            checked={statusBanners}
                            onChange={(checked) => setStatusBanners(checked)}
                          />
                        </Col>
                      </Row>
                    </div>
                  )}

                  {/* ===================== TAB 3: SECTION AD POP-UPS ===================== */}
                  {activeCategoryTab === 'popup' && (
                    <div style={{ marginTop: "16px" }}>
                      <div className="mb-3">
                        <Title level={5} style={{ margin: 0, color: "#1F2937" }}>
                          {t('Section Ad Pop-ups')}
                        </Title>
                        <Text type="secondary" style={{ fontSize: "13px" }}>
                          {t('Pop-up advertisement overlay displayed when users enter specific sections or all sections.')}
                        </Text>
                      </div>

                      {/* Target Section Select (Multi-Select) */}
                      <Row align="middle" gutter={16} className="mb-4">
                        <Col md={4} sm={24} style={{ fontWeight: 500 }}>
                          {t("Target Section")} :
                        </Col>
                        <Col md={20} sm={24}>
                          <SelectComponent
                            mode="multiple"
                            maxTagCount="responsive"
                            options={sectionOptions}
                            value={popupSection}
                            setValue={handleSectionChange}
                            placeholder={t("Select Target Section")}
                          />
                        </Col>
                      </Row>

                      {/* Popup Graphic / GIF Upload Zone */}
                      <Row className='w-100'>
                        <Col md={24} sm={24}>
                          <div className='w-100'>
                            <OSSUploadWrapper
                              allowType={["image/png", "image/jpg", "image/jpeg", "image/gif", "image/webp"]}
                              onUploadSuccess={(value) => {
                                setPopupPicUrl([value]);
                              }}
                            >
                              <DragUploadAdsSettingComponent
                                allowType={["image/png", "image/jpg", "image/jpeg", "image/gif", "image/webp"]}
                                titleallowFile={t(`Support png/jpg/gif and other formats, the maximum file size is 10MB`)}
                                fileList={popupPicUrl ? popupPicUrl : []}
                                setFileList={(values) => {
                                  setPopupPicUrl(values);
                                }}
                              />
                            </OSSUploadWrapper>
                          </div>
                        </Col>
                      </Row>

                      {/* Jump Link Configuration */}
                      <div className="mt-4">
                        <Card
                          className="custom-card"
                          bodyStyle={{ padding: "16px 20px" }}
                          style={{ background: "#FFFFFF", borderRadius: "10px", border: "1px solid #E5E7EB", boxShadow: "0 1px 3px rgba(0,0,0,0.03)" }}
                        >
                          <Tabs
                            activeKey={popupLinkType === "internal" ? "internalList" : "externalList"}
                            className="banner-config-tabs cusStyle"
                            onChange={handlePopupTabChange}
                            items={[
                              {
                                key: "externalList",
                                label: (
                                  <span style={{ display: "inline-flex", alignItems: "center", gap: "6px", fontSize: "13px" }}>
                                    {/* <GlobalOutlined /> */}
                                    <span>{t("External Links")}</span>
                                  </span>
                                ),
                                children: (
                                  <div style={{ paddingTop: "6px" }}>
                                    <div style={{ fontSize: "12px", fontWeight: 500, color: "#4B5563", marginBottom: "6px" }}>
                                      {t("Enter Jump Link")} :
                                    </div>
                                    <InputComponent
                                      placeholder=""
                                      value={popupExternalUrl || ""}
                                      setValue={(value) => setPopupExternalUrl(value)}
                                    />
                                  </div>
                                )
                              },
                              {
                                key: "internalList",
                                label: (
                                  <span style={{ display: "inline-flex", alignItems: "center", gap: "6px", fontSize: "13px" }}>
                                    {/* <ShoppingOutlined /> */}
                                    <span>{t("Internal Links")}</span>
                                  </span>
                                ),
                                children: (
                                  <div style={{ paddingTop: "6px" }}>
                                    <AdsSettingInternalLinkSelector
                                      value={{
                                        linkUrl: popupInternalUrl,
                                        linkId: popupInternalId,
                                        type: popupInternalType,
                                        targetId: popupInternalTargetId
                                      }}
                                      onChange={({ linkUrl, linkId, type, targetId }) => {
                                        setPopupInternalUrl(linkUrl || "");
                                        setPopupInternalId(linkId || null);
                                        setPopupInternalType(type || null);
                                        setPopupInternalTargetId(targetId || null);
                                      }}
                                    />
                                  </div>
                                )
                              }
                            ]}
                          />
                        </Card>
                      </div>

                      {/* Pop-up Ad Status */}
                      <Row align="middle" className='mt-4 mb-4'>
                        <Col md={3} sm={6} style={{ fontWeight: 500 }}>
                          {t("Status")} :
                        </Col>
                        <Col md={21} sm={18}>
                          <Switch
                            checked={statusSectionAds}
                            onChange={(checked) => setStatusSectionAds(checked)}
                          />
                        </Col>
                      </Row>
                    </div>
                  )}

                  <Divider style={{ margin: "20px 0" }} />

                  {/* SUBMIT BUTTON */}
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                      className='b-danger'
                      disabled={loading}
                      type="primary"
                      onClick={handleSubmit}
                      style={{
                        fontSize: '15px',
                        fontWeight: 600,
                        backgroundColor: "#E50A47",
                        borderColor: "#E50A47",
                        color: "#FFFFFF",
                        height: "40px",
                        padding: "0 28px",
                        borderRadius: "6px",
                        opacity: loading ? 0.5 : 1
                      }}
                      danger
                    >
                      {t(`Submit`)}
                    </Button>
                  </div>

                </Card>
              </Col>
            </Row>
          </div>
        </Spin>
      </HeaderComponent>
      <MessageConfirmModal textCentered ref={messageModalRef} />
    </>
  );
};

export default AdsSettingMainPage;